/**
 * Wizard session data for the upload step, rebuilt from an existing, already-paid job.
 * Step4Upload reads it from sessionStorage ('ixbrl_wizard'); a job opened from the Jobs list has none.
 */
export const WIZARD_SESSION_KEY = 'ixbrl_wizard';

export const canResumeUpload = (job) => Boolean(job && job.id && job.companyId && !job.fileName);

export const buildUploadSession = (job, paymentRef) => ({
  paymentType: 'pay_now',
  stripeSessionId: paymentRef, // marks the payment as already verified for Step4Upload
  config: { deliveryTime: job.deliveryTime || 'standard', serviceType: 'expert' },
  optionalServices: [],
  selectedCompanies: [
    { id: job.companyId, name: job.companyName, accountType: job.accountType || 'standard' },
  ],
  createdJobs: [
    { id: job.id, job_id: job.jobId, company_id: job.companyId, company_name: job.companyName },
  ],
});
